<template>
  <div>
    <h3>Role administration</h3>
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!-- Roles -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Roles' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <roles-list />
        </div>
      </vs-tab>

      <!-- Permissions -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Permissions' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <permissions />
        </div>
      </vs-tab>

      <!-- Regions -->
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Regions' : ''"
      >
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <regions />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
//import Venue from '../../venues/venue/Venue.vue';

import RolesList from "./Roles/RolesList.vue";
import Permissions from "./Permissions/Permissions.vue";
import Regions from "./Regions/Regions.vue";

export default {
  components: {
    RolesList,
    Permissions,
    Regions,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },

  created() {},
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
